import { LOGO_URL, INSTAGRAM_URL } from "@/lib/api";
import { Instagram } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-white/5 mt-32 py-16 px-6 md:px-12 bg-[#050505]">
    <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-6">
          <img src={LOGO_URL} alt="Vanguard" className="h-12 w-12 object-contain" />
          <div>
            <div className="font-display font-bold tracking-[0.2em] text-sm gold-gradient">
              VANGUARD
            </div>
            <div className="text-[0.6rem] tracking-[0.3em] text-gray-400 uppercase">
              Lux Cars by Stekoza
            </div>
          </div>
        </div>
        <p className="text-base text-gray-400 leading-relaxed font-light mb-6">
          Επιλεγμένη συλλογή από τα πιο εκλεκτά αυτοκίνητα, διαθέσιμα για αγορά ή ενοικίαση.
        </p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="inline-flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-gray-400 hover:text-[var(--gold)] transition-colors group font-display"
        >
          <span className="h-9 w-9 border border-[var(--gold)]/30 group-hover:border-[var(--gold)] flex items-center justify-center transition-colors">
            <Instagram size={14} />
          </span>
          @vanguardluxcars
        </a>
      </div>
      <div>
        <div className="label-caps mb-4">Έκθεση</div>
        <p className="text-base text-gray-400 leading-loose font-light">
          Η διεύθυνση δίνεται με το ραντεβού<br />
          <span className="font-display tracking-wider text-gray-300">+30 693 322 3378</span>
        </p>
      </div>
      <div>
        <div className="label-caps mb-4">Ωράριο</div>
        <p className="text-base text-gray-300 leading-loose font-display tracking-wider">
          Δευτέρα – Σάββατο: 09:00 – 20:00
        </p>
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/5 flex justify-between items-center">
      <p className="text-xs text-gray-500 tracking-widest uppercase font-display">
        © 2026 Vanguard Lux Cars
      </p>
      <p className="text-xs text-gray-500 tracking-widest uppercase font-display">By Stekoza</p>
    </div>
  </footer>
);
